



















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import NoData from '@/components/NoData'
import { getCompanyInfoRequest} from '@/api/enerySupervision'
import moment from 'moment'
@Component({
 name:'CompanyInfo',
 components:{ NoData}
})
export default class CompanyInfo extends Vue {
  private companyInfo:any={}
  private supervisionCycle:number=new Date().getFullYear()-1
  private action:string='view'
  private ant_button:boolean = true
  async getCompanyInfo(code:any){
    const {status,data}=await getCompanyInfoRequest({id:code})
    if(status==0){
      this.companyInfo=data
      localStorage.setItem('energySavingSystemUrl',JSON.stringify(data.energySavingSystemUrl))
      localStorage.setItem('productionProcessUrl',JSON.stringify(data.productionProcessUrl))  
    }
  }
    handleSearch(obj:any){
        const Time = new Date().getFullYear() -1
        Time == obj.startDate?this.ant_button = true:this.ant_button = false
    }
    created(){
        if(this.$route.query.code){
            this.getCompanyInfo(this.$route.query.code)
            this.action=this.$route.query.action.toString()
        }
    }
}
